import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Form, Table, Modal, Button, Accordion } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import Paginator from "../../components/common/Pagination";
import { formateDatemdy, capitalizeFirstLetter, capitalizeFirstLetterOfEveryWord } from "../../utils/Helper";
import DeleteModal from "../../components/common/DeleteModel";
import Topic_Filter from "../Topic/topic_filter";
import { FaEye, FaEdit, FaTrash,  FaFilePdf } from "react-icons/fa";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import { MdOutlineTextsms } from "react-icons/md";


const Topic = () => {
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const [selectedRange, setSelectedRange] = useState("disabled");
  const [load, setLoad] = useState(false);
  const [errors, setErrors] = useState({});
  const [topicList, setTopicList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [count, setCount] = useState(0);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const [show, setShow] = useState(false);
  const [showDt, setShowDt] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [topicName, setTopicName] = useState("");
  const permissionscontext = useMenuPermissions("/admin/topic");
 


  const handleClose = () => {
    setShow(false);
    setSelectedId(null);
    setErrors({});
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNameChange = (e) => {
    setTopicName(e.target.value);
    setErrors({});
  };

  const handleStatusChange = async (it) => {
    const newStatus = it.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { id: it.id, status: newStatus };
      const res = await APIServices.put(
        `/admin/topics/status`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        const updatedTopicList = topicList.map((item) => {
          if (item.topics) {
            item.topics = item.topics.map((topic) => {
              if (topic.id === it.id) {
                return { ...topic, status: newStatus };
              }
              return topic;
            });
          }
          return item;
        });

        setTopicList(updatedTopicList);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  const handlePublishStatusChange = async (it) => {
    const newStatus =
      it?.published_status === "Published" ? "Draft" : "Published";
    try {
      const payload = { id: it.id, published_status: newStatus };
      const res = await APIServices.put(
        `/admin/topics/publish`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        const updatedTopicList = topicList.map((item) => {
          if (item.topics) {
            item.topics = item.topics.map((topic) => {
              if (topic.id === it.id) {
                return { ...topic, published_status: newStatus };
              }
              return topic;
            });
          }
          return item;
        });

        setTopicList(updatedTopicList);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  useEffect(() => {
    fetchTopicList(currentPage, filters);
  }, [currentPage, filters]);

  const fetchTopicList = async (page = 1, filters) => {
    const params = {
      ...filters,
      skip: (page - 1) * limit,
      limit: limit,
    };

    const queryString = Object.entries(params)
      .filter(
        ([_, value]) => value !== "" && value !== undefined && value !== null
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    try {
      const response = await APIServices.get(
        `/admin/topics/request-list?${queryString}`,
        headers
      );
      if (response?.status === 200) {
        setTopicList(response?.data?.data?.topics || []);
        setCount(response?.data?.data?.total);
        setTotalCount(Math.ceil(response?.data?.data?.total / limit) || 0); // Corrected
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setTopicList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setTopicList([]);
      setTotalCount(0);
    }
  };

  const handleEdit = async () => {
    let newErrors = {};
    if (!topicName?.trim()) {
      newErrors.name = "Please enter topic name.";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }
    setLoad(true);
    try {
      if (selectedId !== null) {
        const payload = { name: topicName };
        const res = await APIServices.put(
          `/admin/topics/${selectedId}`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          fetchTopicList(currentPage, filters);
          setSelectedId(null);
          setLoad(false);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
          setLoad(false);
        }
      }
      setShow(false);
    } catch (error) {
      console.error("Error deleting :", error);
    } finally {
      setLoad(false);
    }
  };
  const handleDelete = async () => {
    try {
      if (selectedId !== null) {
        const payload = { id: selectedId };
        const res = await APIServices.put(
          `/admin/topics/delete/${selectedId}`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");

          const updated = topicList.map((it) => {
            // Filter out the topic where it matches the selectedId
            const updatedTopics = it.topics.filter((topic) => topic.id !== selectedId);

            // Return the updated object with the filtered 'topics' array
            return { ...it, topics: updatedTopics };
          });
          setTopicList(updated);
          setSelectedId(null);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
      setShowDt(false);
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };
  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };
  const [activeKey, setActiveKey] = useState("0");

  return (
    <>
      <div className="Topic_inner">
        <div className="mom_header d-flex align-items-center justify-content-between mb-3">
          <h1 className="font_blue_18 font-600">{`Topics (${count ?? 0})`}</h1>

          <ul className="d-flex align-items-center mom_filter">
            <li
              className="d-flex align-items-center cursor-pointer"
              onClick={() => setShowFilter(true)}
            >
              Filter By{" "}
              <img
                src="/images/Sort.svg"
                className="img-fluid ms-2"
                alt="Sort"
              />
            </li>
            {permissionscontext.add == 1 && (
              <li className="ms-2">
                <button
                  className="btn red_button d-flex align-items-center"
                  onClick={() => navigate("/admin/generate-topic")}
                >
                  <FaPlus className="me-1" />
                  Generate Topic
                </button>
              </li>
            )}
          </ul>
        </div>

        <div className="todoList_table">
          {/* Check if topicList has items */}
          {topicList && topicList.length > 0 ? (
            <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
              {topicList.map((parentItem, parentIndex) => (
                <Accordion.Item
                  eventKey={String(parentIndex)}
                  className="accordion-gap"
                  key={parentItem.id}
                >
                  <Accordion.Header>
                    <div className="heading_box">
                     <p className="me-1">{parentItem?.sr_no ?? ""}.{" "} </p>

                    <h4 className=""> 
                     
                      <p
                          title={parentItem.text} // Native tooltip
                          style={{ cursor: "pointer" }}
                          className="font_blue_16">
                          {parentItem?.text?.length > 100
                            ? `${parentItem.text.substring(0, 100)}...`
                            : parentItem.text}
                          ({parentItem.topics.length || 0})</p>
                     </h4>
                     </div>
                     <div className="date_box">
                    <span className="date d-flex align-items-center me-1"> { parentItem.genreted_from == "pdf"  ? ( <FaFilePdf/>) : ( <MdOutlineTextsms/>)}  </span>
                     <span className="date">{formateDatemdy(parentItem.created_at)}</span>
                     </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div className="table-responsive">
                      <Table className="table">
                        <thead className="table-dark">
                          <tr>
                            <th>Sr.No</th>
                            <th>Topic Name</th>
                            <th>Create Date</th>
                            <th>Approved by</th>
                            <th>Published Status</th>
                            <th>Status</th>
                            <th>Manage</th>
                          </tr>
                        </thead>

                        {parentItem.topics && parentItem.topics.length > 0 ? (
                          <tbody>
                            {parentItem.topics.map((item, index) => (
                              <tr key={item.id}>
                                <td>{item.sr_no}</td>
                                <td>
                                  <h3 className="font_blue_16 textTransform">
                                    {item.name}
                                  </h3>
                                </td>
                                <td>{formateDatemdy(item.created_at)}</td>

                                <td>
                                  {item?.approved_by
                                    ? capitalizeFirstLetterOfEveryWord(item.approved_by)
                                    : "N/A"}
                                </td>

                                {/* Published Toggle */}
                                <td>
                                  <Form className="Switch_toggle">
                                    <input
                                      type="checkbox"
                                      id={`switchP-${item.id}`}
                                      checked={item.published_status === "Published"}
                                      onChange={() => handlePublishStatusChange(item)}
                                      disabled={!permissionscontext.edit}
                                    />
                                    <label
                                      htmlFor={`switchP-${item.id}`}
                                      className="position-relative"
                                    >
                                      Toggle
                                    </label>
                                  </Form>
                                </td>

                                {/* Active Status Toggle */}
                                <td>
                                  <Form className="Switch_toggle">
                                    <input
                                      type="checkbox"
                                      id={`switch-${item.id}`}
                                      checked={item.status === "Active"}
                                      onChange={() => handleStatusChange(item)}
                                      disabled={!permissionscontext.edit}
                                    />
                                    <label
                                      htmlFor={`switch-${item.id}`}
                                      className="position-relative"
                                    >
                                      Toggle
                                    </label>
                                  </Form>
                                </td>

                                {/* Manage Buttons */}
                                <td>
                                  <ul className="d-flex align-items-center justify-content-start topic_action list-unstyled m-0">
                                    <li>
                                      <button
                                        className="btn py-1"
                                        onClick={() =>
                                          navigate(`/admin/topic-detail/${item.id}`)
                                        }
                                      >
                                        <FaEye />
                                      </button>
                                    </li>

                                    {item.no_of_lesson === 0 && (
                                      <>
                                        <li>
                                          <button
                                            className="btn py-1"
                                            onClick={() => {
                                              setSelectedId(item.id);
                                              setTopicName(item.name);
                                              setShow(true);
                                            }}
                                            disabled={!permissionscontext.edit}
                                          >
                                            <FaEdit />
                                          </button>
                                        </li>
                                        <li>
                                          <button
                                            className="btn py-1"
                                            onClick={() => {
                                              setSelectedId(item.id);
                                              setShowDt(true);
                                            }}
                                            disabled={!permissionscontext.delete}
                                          >
                                            <FaTrash />
                                          </button>
                                        </li>
                                      </>
                                    )}
                                  </ul>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        ) : (
                          <tbody>
                            <tr>
                              <td colSpan="7" className="text-center py-5">
                                <h4>Not Available</h4>
                              </td>
                            </tr>
                          </tbody>
                        )}
                      </Table>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          ) : (
            // Display message when topicList is empty
            <div className="text-center py-5">
              <h4>Topics not found</h4>
            </div>
          )}
        </div>


        <div className="pagination_box mt-4">
          {count > 10 && (
            <Paginator
              currentPage={currentPage}
              totalPages={totalCount}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
      <ToastContainer />
      <Modal
        show={show}
        size="md"
        onHide={handleClose}
        centered
        backdrop="static"
        className="add_subproduct msl_model"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="font_blue_20 font-600 ">
            Edit Topic
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          <Row className="mb-3 align-items-start font_blue_18">
            <Col md={12} lg={12}>
              <Form.Group controlId="topicName" className="w-100">
                <Form.Label className="font_blue_14 font-500 ">
                  Name :
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Topic name"
                  value={topicName}
                  onChange={handleNameChange}
                  isInvalid={!!errors.name}
                />
                {errors.name && (
                  <div className="invalid-feedback d-block">{errors.name}</div>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="warning"
            className="success_btn"
            onClick={handleEdit}
            disabled={load}
          >
            {load ? "Processing..." : "Update"}
          </Button>
          <Button
            variant="secondary"
            className="cancel_btn"
            onClick={handleClose}
            disabled={load}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <DeleteModal
        showdt={showDt}
        handleCloseDt={() => setShowDt(false)}
        handledelete={handleDelete}
      />
      {showFilter && (
        <Topic_Filter
          appliedFilters={filters}
          show={showFilter}
          onHide={() => setShowFilter(false)}
          onApplyFilter={(filterData) => {
            setFilters(filterData);
            setShowFilter(false);
            setCurrentPage(1);
          }}
          onClear={() => {
            setFilters({});
            setShowFilter(false);
            setSelectedRange("");
            setCurrentPage(1);
          }}
          setSelectedRange={setSelectedRange}
          selectedRange={selectedRange}
        />
      )}
    </>
  );
};

export default Topic;
